export const GOAL_UNMARKED = 0;
export const GOAL_HIT = 1;
export const GOAL_MISS = 2;
export const GOAL_CHANGED = 3;

export const goalTypes = {
  UNMARKED: {
    value: 0,
    label: 'Unmarked',
  },
  HIT: {
    value: 1,
    label: 'Hit',
  },
  MISS: {
    value: 2,
    label: 'Miss',
  },
  CHANGED: {
    value: 3,
    label: 'Changed',
  },
};

export const EVENT_MOUSEOVER = 'mouseover';
export const TYPE_REPORTING_DAY_YESTERDAY = 1;
export const TYPE_REPORTING_DAY_TODAY = 2;
export const TYPE_REPORTING_DAY_TOMORROW = 3;
